<h5>Enable Global Search</h5>
<p-table [value]="globalSearchConfigData" dataKey="id" rowGroupMode="subheader" groupRowsBy="name">
    <ng-template pTemplate="header">
        <tr>
            <th style="width: 2rem;" scope="col"></th>
            <th style="width: 200px;" scope="col">Name</th>
            <th scope="col">Search Field</th>
            <th scope="col">Displayable Field</th>
            <th style="width: 100px;" scope="col">Action</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-module let-rowIndex="rowIndex" let-expanded="expanded">
        <tr class="parentRow">
            <td class="action">
                <button type="button" pButton pRipple [pRowToggler]="module" 
                class="p-button-text p-button-rounded p-button-plain" 
                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
            </td>
            <td colspan="3">{{module.moduleName}}</td>
            <td class="action">
                <span class="btnBars" (click)="editField(module)">
                    <i class="pi pi-pencil"></i>
                </span>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-module>
        <ng-container *ngFor="let section of module.sections">
          <tr>
            <th class="header" scope="col">
            </th>
            <th class="header" scope="col">
              <h5>{{section.name}}</h5>
            </th>
            <th class="header" scope="col">
            </th>
            <th class="header" scope="col">
            </th>
            <th class="header" scope="col">
            </th>
          </tr>
            <ng-container *ngFor="let field of section.fields">
                <tr [hidden]="!field.searchEnabled && !field.isDisplayed">
                    <td></td>
                    <td></td>
                    <td *ngIf="field.searchEnabled">
                        {{field.name}}
                    </td>
                    <td *ngIf="!field.searchEnabled">
                      
                    </td>
                    <td *ngIf="field.isDisplayed">
                        {{field.name}}
                    </td>
                    <td *ngIf="!field.isDisplayed">
                      
                    </td>
                    <td>
                      
                    </td>
                </tr>
            </ng-container>
        </ng-container>
    </ng-template>
</p-table>

<p-dialog header="{{moduleHeader}}" [(visible)]="displayModuleFields"
[modal]="true" [responsive]="true" [style]="{width: '60em'}">
    <div class="card">
      <div class="p-grid" *ngFor="let section of moduleTemp?.sections; let i = index">
        <div class="p-col-12">
          <div class="p-grid" *ngIf="i == 0">
            <h6 class="p-col p-mb-2 p-pl-4">Label Name</h6>
            <div style="width:50px" class="p-text-center">
              <span class="btnBars" style="cursor: default;"
              pTooltip="Global Search" tooltipPosition="top">
                <i class="pi pi-globe" style="font-size: 15px;"></i>
              </span>
            </div>
            <div style="width:50px" class="p-mb-2 p-text-center">
              <span class="btnBars" style="cursor: default;"
              pTooltip="Displayable Fields" tooltipPosition="top">
                <i class="pi pi-file" style="font-size: 15px;"></i>
              </span>
            </div>
          </div>
          <p-table [value]="section.fields" dataKey="code" styleClass="editable">
            <ng-template pTemplate="header">
              <tr>
                <th class="header" scope="col">
                  <h5>{{section.name}}</h5>
                </th>
                <th style="width: 50px;" class="p-text-center header" scope="col">
                    <p-checkbox [ngModelOptions]="{standalone: true}" 
                    [disabled]="selectedSectionHeaderForGloablSearch[i]"
                    (click)="checkUncheckSectionHeader(ct1.checked, i, moduleTemp, section, 'gloablSearch')" #ct1
                    ngDefaultControl [(ngModel)]="selectedSectionHeaderForGloablSearch[i]" binary="true"></p-checkbox>
                </th>
                <th style="width: 50px;" class="p-text-center header" scope="col">
                  <p-checkbox [ngModelOptions]="{standalone: true}" 
                  [disabled]="selectedSectionHeaderForDisplay[i]"
                  (click)="checkUncheckSectionHeader(ct2.checked, i, moduleTemp, section, 'display')" #ct2
                  ngDefaultControl [(ngModel)]="selectedSectionHeaderForDisplay[i]" binary="true"></p-checkbox>
              </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-field let-expanded="expanded">
              <tr>
                <td>{{field.name}}
                  <span style="color: red;" *ngIf="field.isRequired">*</span>
                </td>
                <td class="p-text-center action">
                  <p-checkbox [ngModelOptions]="{standalone: true}" [value]="label" ngDefaultControl
                  binary="true" [(ngModel)]="field.searchEnabled" (click)="checkUncheckField(i, field, moduleTemp, section, 'gloablSearch')"
                  [disabled]="field.isRequired"></p-checkbox>
                </td>
                <td class="p-text-center action">
                  <p-checkbox [ngModelOptions]="{standalone: true}" [value]="label" ngDefaultControl
                  binary="true" [(ngModel)]="field.isDisplayed" (click)="checkUncheckField(i, field, moduleTemp, section, 'display')"
                  [disabled]="field.isRequired"></p-checkbox>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>

  <p-footer>
    <button type="button" pButton (click)="cancelFieldUpdatePopUp()" label="Cancel"
      class="p-button-secondary"></button>
    <button type="button" pButton (click)="updateFields()" [disabled]="editFieldsModel?.updateGlobalSearchConfigData.length < 1" label="Save"></button>
  </p-footer>
</p-dialog>